<template>
    <div>
        <vSelect :options="lineOptions" v-model="line" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


export default {
    name: "LineSelect",
    components: {
        vSelect
    },
    props: {
        value: String
    },
    computed: {
        lineOptions: function() {
            var ret = [];
            if( this.listData )
                for( var a of this.listData ) {
                    ret.push({code: a.tunnus, label:a.tunnus + ' ' + a.nimi})
                }
            return ret;
        },
        line: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        },
        listData() {
            return this.$store.state.timetable.lines.list;
        },     
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
    },
    mounted() {
         if(!this.listData || this.listData.length === 0) 
             this.$store.dispatch('timetable/getLinesListData')
    }
}
</script>